import { SegmentedControl } from '@mantine/core';
import classes from './segmented-control.module.css';
// TODO Segmented control styles & props
export const segmentedControlProps = SegmentedControl.extend({
    classNames: classes,
});
